import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Accordion } from "@mantine/core";
import Article from "./Article";
import { formatPrice, formatReceiptNumber, formatSaleDate } from "./util";

const useStyles = makeStyles((theme) => ({
  accordionControl: {
    border: `1px solid ${theme.app.borderColor}`,
    borderRadius: "4px",
    marginTop: "8px",
    padding: "20px",
    "@media(max-width: 667px)": {
      padding: "10px",
    },
    "& div:first-child": {
      marginLeft: "0",
      width: "unset",
      minWidth: "unset",
    },
    "& div:not(:first-child)": {
      display: "flex",
      flexDirection: "row",
      gap: "50px",
      "@media(max-width: 800px)": {
        gap: "25px",
      },
      "@media(max-width: 667px)": {
        gap: "10px",
      },

      "& span": {
        width: "150px",
      },
    },
  },
  articleContainer: {
    minHeight: "200px",
    border: `1px solid ${theme.app.borderColor}`,
    borderTop: "none",
    borderRadius: "4px",
  },
}));

const ArticleContainer = (props) => {
  const classes = useStyles();
  const { sale, value } = props;
  const { posName, totalInclVat } = sale;
  const formattedReceiptNumber = formatReceiptNumber(sale.receiptNumber);

  return (
    <Accordion.Item
      style={{ border: "none" }}
      value={formattedReceiptNumber}
      key={formattedReceiptNumber}
    >
      <Accordion.Control className={classes.accordionControl}>
        <span>{formatSaleDate(sale.saleDate)}</span>
        <span>{formattedReceiptNumber}</span>
        <span>{posName}</span>
        <span>{formatPrice(totalInclVat)}</span>
      </Accordion.Control>
      <Accordion.Panel>
        <div className={classes.articleContainer}>
          {value === formattedReceiptNumber && <Article sale={sale} />}
        </div>
      </Accordion.Panel>
    </Accordion.Item>
  );
};

export default ArticleContainer;
